<div class="flex flex-inline">
    <p-button class="tpHistoryBtn" (onClick)="modalTpHistory.showDialog()">History</p-button>
</div>

<app-modal-tp-history #modalTpHistory />